import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import {useStyles} from './helpers';

const DialogCancel = ({openModal, setOpenModal, submit}) => {
    const classes = useStyles();
    const [valTextarea, setValTextarea] = React.useState('');

    return (
        <Dialog onClose={() => setOpenModal(false)} open={openModal}>
            <div className={classes.wrapDialog}>
                <h3 className={classes.titleDialog}>Опишите причину отказа</h3>
                <div className={classes.wrap}>
                    <textarea name="" id=""  rows="10"
                        value={valTextarea}
                        className={classes.textarea}
                        onChange={(v) => setValTextarea(v.target.value)}
                    ></textarea>
                    <div className={classes.wrapDialogButton}>
                        <span 
                            className={classes.dialogButton}
                            onClick={() => {
                                submit({
                                    type: 'cancel',
                                    description: valTextarea
                                })
                            }}
                        >
                            Отправить
                        </span>
                    </div>
                    
                </div>
                
            </div>
        </Dialog>
    )
}

export default DialogCancel;